import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FunctionUtil } from './function.util';

export function maxFileSize(maxSize: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors|null => {
    const files: File[] = Array.isArray(control.value) ? control.value : [control.value];
    let index = 0;

    while (files[index]) {
      if (files[index].size > maxSize) {
        return {
          maxFileSize: {
            invalid: true,
            size: FunctionUtil.formatFileSize(maxSize),
          },
        };
      } else {
        index += 1;
      }
    }

    return null;
  };
}

export function minFileSize(minSize: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors|null => {
    const files: File[] = Array.isArray(control.value) ? control.value : [control.value];
    let index = 0;

    while (files[index]) {
      if (files[index].size < minSize) {
        return {
          minFileSize: {
            invalid: true,
            size: FunctionUtil.formatFileSize(minSize),
          },
        };
      } else {
        index += 1;
      }
    }

    return null;
  };
}

